import { ComponentRef, Directive, ElementRef, Input, Renderer2, ViewContainerRef } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Directive({
  selector: '[appButtonLoading]',
})
export class ButtonLoadingDirective {
  @Input('appButtonLoading') loading: boolean;
  @Input('spinnerDiameter') diameter: number = 17;

  private spinner: ComponentRef<MatProgressSpinner>;
  private icon: ComponentRef<MatIcon>;
  private initialized = false;

  constructor(private el: ElementRef, private renderer: Renderer2, private viewContainerRef: ViewContainerRef) {}

  private prepareSpinner() {
    this.renderer.addClass(this.icon.location.nativeElement, 'ml-2');
    this.renderer.setStyle(this.icon.location.nativeElement, 'width', `${this.diameter}px`);
    this.renderer.setStyle(this.icon.location.nativeElement, 'height', `${this.diameter}px`);
    this.renderer.appendChild(this.icon.location.nativeElement, this.spinner.location.nativeElement);
    this.spinner.instance.diameter = this.diameter;
    this.spinner.instance.mode = 'indeterminate';
  }

  private append() {
    if (this.initialized) {
      this.renderer.setStyle(this.icon.location.nativeElement, 'display', 'inline-block');
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'disabled');
      this.renderer.appendChild(this.el.nativeElement, this.icon.location.nativeElement);
    }
  }

  private remove() {
    if (this.initialized) {
      this.renderer.setStyle(this.icon.location.nativeElement, 'display', 'none');
      this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
      this.renderer.removeChild(this.el.nativeElement, this.icon.location.nativeElement);
    }
  }

  private handleChanges() {
    if (this.loading) {
      this.append();
    } else {
      this.remove();
    }
  }

  ngOnInit() {
    this.spinner = this.viewContainerRef.createComponent(MatProgressSpinner);
    this.icon = this.viewContainerRef.createComponent(MatIcon);

    this.prepareSpinner();

    this.initialized = true;
  }

  ngAfterViewInit() {
    this.handleChanges();
  }

  ngOnChanges() {
    this.handleChanges();
  }
}
